module.exports = __webpack_public_path__ + "img/subscribe-image.0cdd502e.png";